<!-- 资金管理-授信記錄 -->
<template>
  <div>
    <page :url="url"
          :form="form"
          @reset="reset"
          :sort-info="{ prop: 'createTimeL', order: 'descending' }">
      <template slot="tableSearch">
        <el-form-item :label="$t('text.status')">
          <el-select v-model="form.status"
                     :placeholder="$t('text.status')">
            <el-option :label="$t('option.all')"
                       value=""/>
            <el-option :label="$t('creditStatus.00')"
                       value="00"/>
            <el-option :label="$t('creditStatus.01')"
                       value="01"/>
            <el-option :label="$t('creditStatus.02')"
                       value="02"/>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('text.settlementStatus')">
          <el-select v-model="form.settlementStatus"
                     :placeholder="$t('text.settlementStatus')">
            <el-option :label="$t('option.all')"
                       value=""/>
            <el-option :label="$t('settlementStatus.00')"
                       value="00"/>
            <el-option :label="$t('settlementStatus.01')"
                       value="01"/>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('text.date')">
          <el-date-picker v-model="timeDate"
                          type="daterange"
                          format="yyyy-MM-dd"
                          value-format="yyyyMMdd"
                          :range-separator="$t('text.to')"
                          :start-placeholder="$t('text.startDate')"
                          :end-placeholder="$t('text.endDate')"
                          @change="timeChange"/>
        </el-form-item>
      </template>

      <template slot="tableColumn">
        <el-table-column
            width="250"
            prop="orderId"
            :label="$t('text.orderNumber')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="status"
            :label="$t('text.creditStatus')"
            width="100px"
            :formatter="$formatter.formatCreditStatus"
            align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
                size="small"
                :type="row.status === '00'? 'warning': row.status === '01'? 'success': 'danger'"
            >{{
                $formatter.formatCreditStatus(null, null, row.status, null)
              }}
            </el-tag
            >
          </template>
        </el-table-column>

        <el-table-column prop="settlementStatus"
                         :formatter="$formatter.formatSettlementStatus"
                         width="100px"
                         :label="$t('text.whetherToSettle')"
                         align="center"/>

        <el-table-column
            prop="availableAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.creditAvailableAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="grantedAmount"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.creditGrantedAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="amount"
            :formatter="$formatter.FenToYuanToThousandth"
            width="130px"
            :label="$t('text.creditAmount')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="createTimeFormat"
            :label="$t('text.creationTime')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="remark"
            :label="$t('text.applicationNote')"
            align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.remark">
              <el-popover
                  v-if="row.remark.length > 10"
                  placement="top-start"
                  width="300"
                  trigger="hover"
                  :content="row.remark"
              >
                <div slot="reference" class="remark">{{ row.remark }}</div>
              </el-popover>
              <div v-else>{{ row.remark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
            width="160"
            prop="dealTimeFormat"
            :label="$t('text.processingTime')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="approveRemark"
            :label="$t('text.approvalRemark')"
            align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.approveRemark">
              <el-popover
                  v-if="row.approveRemark && row.approveRemark.length > 10"
                  placement="top-start"
                  width="300"
                  trigger="hover"
                  :content="row.approveRemark"
              >
                <div slot="reference" class="remark">
                  {{ row.approveRemark }}
                </div>
              </el-popover>
              <div v-else>{{ row.approveRemark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </template>
    </page>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";

export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/creditApplicationRecord/selectList",
      timeDate: [],
      form: {
        status: "",
        orderId: "",
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>